// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".site-footer[data-v-d3849590] {\n  background-color: #252525;\n}", ""]);
// Exports
module.exports = exports;
